
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256.61 256.61"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.859 112.533c-6.853 0-6.853 10.646 0 10.646h81.875c6.865 0 6.865-10.646 0-10.646H60.859zM142.734 137.704H60.859c-6.853 0-6.853 10.634 0 10.634h81.875c6.866 0 6.866-10.634 0-10.634zM142.734 161.018H60.859c-6.853 0-6.853 10.633 0 10.633h81.875c6.866-.001 6.866-10.633 0-10.633zM142.734 186.184H60.859c-6.853 0-6.853 10.629 0 10.629h81.875c6.866-.001 6.866-10.629 0-10.629zM141.17 209.934H59.28c-6.848 0-6.848 10.633 0 10.633h81.89c6.845-.001 6.845-10.633 0-10.633z"}}),_c('path',{attrs:{"d":"M25.362 58.087V256.61h152.877V85.63l-28.406-27.543H25.362zm139.664 185.306H38.585V71.305h104.443v20.97h21.988v151.118h.01z"}}),_c('path',{attrs:{"d":"M51.204 27.667v22.978h13.223V40.88h104.448v20.97h21.993v151.121h-5.809v13.217h19.027V55.205L175.68 27.667z"}}),_c('path',{attrs:{"d":"M202.837 0H78.363v22.983h13.218v-9.765h104.451v20.97h21.993v151.118h-5.804v13.217h19.027V27.543z"}})])
          )
        }
      }
    